export default (props = {}) => <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"{...props}>
<path d="M22.5 5.25H1.5V3.75H22.5V5.25Z"/>
<path d="M22.5 11.25H1.5V12.75H22.5V11.25Z"/>
<path d="M1.5 18.75H22.5V20.25H1.5V18.75Z"/>
</svg>
